import { IconCross } from '@speechki-frontend/shared/ui/icons';

export const debug = (...args) => console.info('[Notify]: ', ...args);

export const PLACEMENTS = Object.freeze({
    TOP_RIGHT: 'top-right',
    TOP: 'top',
    TOP_LEFT: 'top-left',
    BOTTOM_RIGHT: 'bottom-right',
    BOTTOM: 'bottom',
    BOTTOM_LEFT: 'bottom-left'
});

export const ICON_TYPES = ['success', 'info', 'error', 'warning'];

export const CONFIG_PROPS = (config = {}) => ({
    top: '25px',
    bottom: '25px',
    duration: 3000,
    prefixCls: 'notify__notice',
    type: 'info',
    placement: PLACEMENTS.BOTTOM_RIGHT,
    getContainer: () => document.body,
    closeIcon: IconCross,
    rtl: false,
    maxCount: Infinity,
    ...config
});
